import { render, staticRenderFns } from "./AffirmBookList.vue?vue&type=template&id=ec30a2c6&"
import script from "./AffirmBookList.vue?vue&type=script&lang=js&"
export * from "./AffirmBookList.vue?vue&type=script&lang=js&"
import style0 from "./AffirmBookList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports